import React from "react";
import { render, unmountComponentAtNode } from "react-dom";

import Modal from "./App";

const rootElementId = "mutual_match_modal";

const appendRootElement = () => {
	const previousModal = document.getElementById(rootElementId);

	if (previousModal) {
		previousModal.remove();
	}

	const rootElement = window.document.createElement("div");
	rootElement.id = rootElementId;

	window.document.body.appendChild(rootElement);

	return rootElement;
};

const ConnectionModal = {
	open(props) {
		render(
			(
				<Modal {...props} />
			),
			appendRootElement()
		);
	},

	close() {
		const rootElement = document.getElementById(rootElementId);

		if (rootElement) {
			unmountComponentAtNode(rootElement);
		}
	},
};

window.ConnectionModal = ConnectionModal;

export default ConnectionModal;



// WEBPACK FOOTER //
// ./src/shared/components/ConnectionModal/index.js